import React from "react";
import { Link } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';

const BYU_NAVY = "#002E5D";
const BYU_BLUE = "#0057B7";
const BYU_BG = "#F5F7FA";

const Home = () => (
    <section
        className="d-flex align-items-center justify-content-center flex-column flex-lg-row"
        style={{
            flex: 1, // <-- This makes it grow to fill the parent
            display: "flex",
            minHeight: 0, // <-- Helps with flexbox layouts
            background: BYU_BG,
            padding: "2rem 0",
        }}
    >
        <div className="flex-grow-1 px-4 py-5">
            <h1
                style={{
                    fontWeight: 800,
                    fontSize: "3.5rem",
                    lineHeight: 1.1,
                    marginBottom: "1rem",
                    color: BYU_NAVY,
                }}
            >
                Cybersecurity,{" "}
                <span style={{ color: BYU_BLUE }}>AI, Software Engineering</span>
            </h1>
            <p
                className="lead"
                style={{
                    maxWidth: 600,
                    fontSize: "1.35rem",
                    color: BYU_NAVY,
                    marginBottom: "2.5rem",
                }}
            >
                I'm Adam Griffin, and I love all things tech. I build quality software,
                help secure systems, and build the best teams.
            </p>
            <div className="d-flex gap-3 mb-4">
                <Link
                    to="/projects"
                    className="btn btn-primary btn-lg px-4"
                    style={{
                        borderRadius: 12,
                        background: BYU_NAVY,
                        borderColor: BYU_NAVY,
                    }}
                >
                    My Projects
                </Link>
                <Link
                    to="/contact"
                    className="btn btn-outline-primary btn-lg px-4"
                    style={{
                        borderRadius: 12,
                        color: BYU_NAVY,
                        borderColor: BYU_NAVY,
                    }}
                >
                    Get In Touch
                </Link>
                <Link
                    to="/about"
                    className="btn btn-outline-primary btn-lg px-4"
                    style={{
                        borderRadius: 12,
                        color: BYU_NAVY,
                        borderColor: BYU_NAVY,
                    }}
                >
                    About Me
                </Link>
            </div>
            <div className="d-flex gap-3 mt-3">
                <Link
                    to="https://www.linkedin.com/in/adamgriffin1"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                >
                    <i className="bi bi-linkedin" style={{ fontSize: 28, color: "#0057B7" }}></i>
                </Link>
                <Link to="https://github.com/adamlg1" target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-github" style={{ fontSize: 28, color: BYU_BLUE }}></i>
                </Link>
            </div>
        </div>
        <div className="flex-grow-1 d-flex justify-content-center align-items-center">
            <div
                style={{
                    background: "#fff",
                    border: `6px solid ${BYU_BLUE}`,
                    borderRadius: 24,
                    boxShadow: "0 6px 32px rgba(0,46,93,0.08)",
                    padding: "2.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 340,
                    minHeight: 0,
                    flex: 1,
                }}
            >
                <img
                    src={process.env.PUBLIC_URL + "/logo.png"}
                    alt="Adam Griffin Logo"
                    style={{
                        width: 220,
                        height: 220,
                        objectFit: "contain",
                        display: "block",
                    }}
                />
            </div>
        </div>
    </section>
);

export default Home;